export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13951.3d3cf65b.jpg";